import appAxios from 'voxguru-v1/api/appAxios';

const makeDeleteRequest = async (endpoint) => {
  const { data } = await appAxios.delete(endpoint);
  return data;
};

export default makeDeleteRequest;
